import { RECORD_TYPES } from "@/react/components/shared/CommunityMemberPicker/types";

import { appendQueryString } from "./appendQueryString";
import { postsPath } from "./posts";

type Params = Record<string, any>;

// Entity types come from two sources: search results use "lesson", the
// sgid-to-object map uses the model name "Courses::Lesson".
const LESSON_TYPES = ["lesson", "courses::lesson"];

interface EntitiesParams {
  lesson_id?: number;
  params?: Params;
  section_id?: number;
  slug: string;
  space_slug: string;
  type: string;
}

export const entitiesPath = ({
  type,
  slug,
  space_slug,
  section_id,
  lesson_id,
  params = {},
}: EntitiesParams) => {
  const entityType = type.toLowerCase();

  if (entityType === RECORD_TYPES.SPACE) {
    return appendQueryString(`/c/${slug}`, params);
  }

  if (LESSON_TYPES.includes(entityType)) {
    return appendQueryString(
      `/c/${space_slug}/sections/${section_id}/lessons/${lesson_id}`,
      params,
    );
  }

  return postsPath({ spaceSlug: space_slug, slug, params });
};

interface EntityHrefParams {
  id?: number;
  params?: Params;
  section_id?: number;
  slug?: string;
  space_slug?: string;
  type: string;
  url?: string;
}

/**
 * Resolves where an entity chip should link to. Serialized entities carry an
 * absolute `url`, but entities picked from search or from an unfurled link only
 * carry their path attributes, so build the path from those instead.
 */
export const entityHref = ({
  url,
  type,
  slug,
  space_slug,
  section_id,
  id,
  params,
}: EntityHrefParams): string =>
  url ||
  entitiesPath({
    type,
    slug: slug ?? "",
    space_slug: space_slug ?? "",
    section_id,
    lesson_id: id,
    params,
  });
